import { useState } from 'react'


const useSelect = (type) => {
  const [initValue, setInitValue] = useState('');
  const [defaultValue, setDefaultValue] = useState('');
  const [error, setError] = useState(null);

  function validate(value) {
    if (value === '') {
      if (type === 'uf') {
        setError('Preencha o uf');
      } else {
        setError('Preencha o campo corretamente!');
      }
      return false;
    } else {
      setError(null);
      return true;
    }
  }


function clearField() {
  setInitValue('');
  setDefaultValue('');
  setError(null);
}

function upDateValue(evel){
  setInitValue(evel)
}

function upDateDefaultValue(evel){
  setDefaultValue(evel)
}

return {
    initValue,
    value: defaultValue || '',
    type,
    error,
    onBlur: () => validate(initValue),
    validate: () => validate(initValue),
    upDateValue: (evel) => upDateValue(evel),
    upDateDefaultValue: (evel) => upDateDefaultValue(evel),
    clearField:clearField,
  }
}

export default useSelect
